export class Audit {
}

Audit.yearlyAuditCount = (audits) => {
	const nowYear = new Date().getFullYear()
	
	return audits.filter((audit) => {
		const year = new Date(audit.created).getFullYear()		
		return year == nowYear
	}).length
}


// WEBPACK FOOTER //
// ./lib/audit/models.js